/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Settings_Tab_GeneralInputs */



/**
* | output |
* | --- |
* | "General" |
*
* @param {Teams_Settings_Tab_GeneralInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_settings_tab_general = /** @type {((inputs?: Teams_Settings_Tab_GeneralInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Settings_Tab_GeneralInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Allgemein")
	return /** @type {LocalizedString} */ ("General")
});